import { NavLink } from "react-router-dom";
import { usePanelItems } from "../../hooks/usePanelItems";
import SubItem from "./SubItem";

interface MenuItemProps {
  expanded?: boolean;
}

const MenuItem = ({ expanded = true }: MenuItemProps) => {
  const panelItems = usePanelItems();

  return (
    <>
      {panelItems.map((menuTitle: any, i: number) =>
        menuTitle.items ? (
          <SubItem
            key={menuTitle.label}
            label={menuTitle.label}
            icon={menuTitle.icon}
            items={menuTitle.items}
            expanded={expanded}
          />
        ) : (
          <NavLink to={menuTitle.path} key={menuTitle.path} className="menu-item-link">
            {({ isActive }) => (
              <div
                className={`menu-item-btn flex align-items-center ${isActive ? "active" : ""} ${!expanded ? "collapsed" : ""}`}
                title={!expanded ? menuTitle.label : ""}
              >
                <i className={`${menuTitle.icon} menu-item-icon`} />
                {expanded && <span className="menu-item-label">{menuTitle.label}</span>}
              </div>
            )}
          </NavLink>
        )
      )}
    </>
  );
};

export default MenuItem;
